<template>
	<div id="modal-timeline-project-popup" >
		<div class="dimmer" @click="onDimmerClick"></div>
		<div class="popup">

			<p class="align-c"><b>{{project.name}}</b></p>
			<br><br>

			<div class="grid">
				<div class="col m50">
					<inputfield label="Startdato (dd-mm-ååååå)">
						<input type="date" :value.number="project.start_date" ref="project_start_date" @change="updateProject(project,'start_date')">
					</inputfield>
				</div>
				<div class="col m50">
					<inputfield label="Afslutningsdato (dd-mm-ååååå)">
						<input type="date" :value.number="project.end_date" ref="project_end_date" @change="updateProject(project,'end_date')">
					</inputfield>
				</div>
			</div>

			<br><br>

			<div class="grid">
				<div class="col m50">
					<inputfield label="Opgave færdig %">
						<input type="number" min="0" max="100" :value.number="project.done_pct" ref="project_done_pct" @change="updateProject(project,'done_pct')">
					</inputfield>
				</div>
				<div class="col m50">
					<inputfield label="Status">
						<select v-model="project.status" @change="updateProjectStatus" ref="project_status">
							<option :value="key" v-for="(status,key,i) in globals.projectStatuses">{{status.title}}</option>
						</select>
					</inputfield>
				</div>
			</div>

			<br><br>

			<a class="btn color2 block full" @click="close" :href="'#/project/'+project['.key']">
				Gå til opgave
			</a>

			<div class="close-btn" @click="close()">X</div>
		</div>
	</div>
</template>

<script>
import fdb from '.././firebase_config.js';
import mixins from '../mixins.js'
import Inputfield from '.././components/Inputfield'
export default {
	//name: 'leftnavbar',
	mixins: [ mixins.db, mixins.generic ],
	components: { Inputfield },
	data() {
		return {
			app: window.globalAppData,
			globals: globals,
			//user: auth.getUser(),
			closeOnDimmerClick: true,
		}
	}, // data
	computed: {

		project(){
			return globals.modal_timeline_project_popup.project
		},

	},
  	methods: {

		updateProjectStatus(e){
			this.project.status = e.target.value
			this.updateProject(this.project, 'status')
		},

		updateProject( project, param ){
			var key = project['.key']
	        var val = this.$refs['project_'+param].value
			var patch = {}
			patch[param] = val
	        fdb.ref('projects').child(key).update(patch)
	        eventBus.$emit('toast', {text:'Opdateret'})
		},

		onDimmerClick(){
			if( this.closeOnDimmerClick ) this.close()
		},

		close(){
			globals.modal_timeline_project_popup.active = false
		},

		clickGotoProject(e){
			e.preventDefault()
			this.close()
			var url = globals.url + '#/project/'+this.project['.key']
			window.open(url)
			return false
		}

	}, //methods

}
</script>



// WEBPACK FOOTER //
// modal-timeline-project-popup.vue?61132a09